module.exports = __webpack_public_path__ + "static/img/industry4.6682b38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/industry4.png
// module id = GEiN
// module chunks = 0